module.exports = __webpack_public_path__ + "static/media/learn-more.39dedaf0.svg";